import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { setToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setToken(data.token);
        setUser(data.user);
        window.history.replaceState({}, "", "/");
        navigate(data.user.onboarding_complete ? "/home" : "/onboarding", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="mm-frame mm-glow flex flex-col items-center justify-center gap-4">
      <Logo size={56} />
      <p className="text-slate-500 text-sm">Signing you in…</p>
    </div>
  );
}
